export default __webpack_public_path__ + "static/media/three.21477439.png";